import { useExtractionConfig, useUpdateConfig, useExecuteExtraction } from '@/hooks/useKnowledge';
import { ConfigForm } from '@/components/knowledge/ConfigForm';
import { ExtractionExecutor } from '@/components/knowledge/ExtractionExecutor';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

export function KnowledgeExtractionSettingsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/knowledge');
    }
  };
  const { data: config, isLoading } = useExtractionConfig();
  const updateMutation = useUpdateConfig();
  const executeMutation = useExecuteExtraction();

  if (isLoading) {
    return (
      <div className="container mx-auto py-8">
        <div className="text-center py-12 text-muted-foreground">
          Carregando configurações...
        </div>
      </div>
    );
  }

  if (!config) {
    return (
      <div className="container mx-auto py-8">
        <div className="text-center py-12 text-muted-foreground">
          Configuração não encontrada
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-8 space-y-8">
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
        <h1 className="text-3xl font-bold">Configuração de Extração de Conhecimento</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <h2 className="text-xl font-semibold mb-4">Configuração Automática</h2>
          <ConfigForm
            config={config}
            onSubmit={(data) => updateMutation.mutate(data)}
            isLoading={updateMutation.isPending}
          />
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-4">Execução Manual</h2>
          <ExtractionExecutor
            onExecute={(data) => executeMutation.mutateAsync(data)}
            isLoading={executeMutation.isPending}
          />
        </div>
      </div>
    </div>
  );
}
